"use client";

import { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import ContactForm from './ContactForm';
import { Button } from '@/components/ui/button';
import { MessageSquare } from 'lucide-react';

export default function ContactFormPopup() {
  const [isOpen, setIsOpen] = useState(false);
  const [hasUserClosed, setHasUserClosed] = useState(false);

  // Check if user has previously closed the popup
  useEffect(() => {
    const popupClosed = localStorage.getItem('popupClosed');
    if (popupClosed === 'true') {
      setHasUserClosed(true);
    }
  }, []);

  // Open popup after 30% scroll if user hasn't closed it before
  useEffect(() => {
    if (hasUserClosed) return;

    const handleScroll = () => {
      const scrollPercentage = (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100;
      if (scrollPercentage >= 30 && !isOpen) {
        setIsOpen(true);
        // Remove the scroll event listener after showing the popup
        window.removeEventListener('scroll', handleScroll);
      }
    };

    // Add scroll event listener
    window.addEventListener('scroll', handleScroll);
    
    // Cleanup
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isOpen, hasUserClosed]);

  const openPopup = () => {
    setIsOpen(true);
  };

  const closePopup = () => {
    setIsOpen(false);
    setHasUserClosed(true);
    // Remember that user closed the popup in localStorage
    localStorage.setItem('popupClosed', 'true');
  };

  return (
    <>
      {/* Floating button */}
      <div className="fixed bottom-6 right-6 z-40">
        <Button
          onClick={openPopup}
          className="h-14 w-14 rounded-full bg-blue-600 hover:bg-blue-700 text-white shadow-lg flex items-center justify-center"
          aria-label="Get My Lead Report Now"
          title="Get My Lead Report Now"
        >
          <MessageSquare className="h-6 w-6" />
        </Button>
      </div>

      {/* Popup overlay */}
      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-2 sm:p-4">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-[95vw] sm:max-w-md md:max-w-lg lg:max-w-xl relative animate-fade-in-up max-h-[95vh] overflow-y-auto">
            <button
              onClick={closePopup}
              className="sticky top-0 right-0 float-right m-3 text-gray-500 hover:text-gray-700 bg-white rounded-full p-1 shadow-sm z-10"
              aria-label="Close"
            >
              <X className="h-5 w-5" />
            </button>
            <div className="p-4 sm:p-5 md:p-6 pt-2">
              <ContactForm />
            </div>
          </div>
        </div>
      )}
    </>
  );
}
